import { combineReducers } from '@reduxjs/toolkit';

import { mfaSlice } from './slices/mfa';
import { tourSlice } from './slices/tour';
import { authSlice } from './slices/auth';
import { chatSlice } from './slices/chat';
import { coachSlice } from './slices/coach';
import { audioSlice } from './slices/audio';
import { assetSlice } from './slices/asset';
import { reviewSlice } from './slices/review';
import { activitySlice } from './slices/activity';
import { taxonomySlice } from './slices/taxonomy';
import { productionSlice } from './slices/production';
import { teamProfileSlice } from './slices/teamProfile';
import { notificationSlice } from './slices/notification';
import { coachConsoleSlice } from './slices/coachConsole';
import { coachInsightsSlice } from './slices/coachInsights';
import { supportConsoleSlice } from './slices/supportConsole';
import { notificationFrameworkSlice } from './slices/notificationFramework';

const combinedReducer = combineReducers({
  auth: authSlice.reducer,
  coachInsights: coachInsightsSlice.reducer,
  chat: chatSlice.reducer,
  coach: coachSlice.reducer,
  coachConsole: coachConsoleSlice.reducer,
  supportConsole: supportConsoleSlice.reducer,
  production: productionSlice.reducer,
  teamProfile: teamProfileSlice.reducer,
  tour: tourSlice.reducer,
  audio: audioSlice.reducer,
  review: reviewSlice.reducer,
  asset: assetSlice.reducer,
  activity: activitySlice.reducer,
  taxonomy: taxonomySlice.reducer,
  notification: notificationSlice.reducer,
  notificationFramework: notificationFrameworkSlice.reducer,
  // mfa stays out of the persist whitelist (src/store/index.js) so MFA tokens,
  // the otpauth secret, and recovery codes never reach localStorage.
  mfa: mfaSlice.reducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'auth/logout' || action.type === 'auth/sessionExpired') {
    return combinedReducer(undefined, action);
  }
  return combinedReducer(state, action);
};

export default rootReducer;
